import * as React from 'react';

interface Props {
  url?: string;
}

export default function Header(props?: Props) {
  return (
    <>
      <header className="main-header">
        <div className="logo">
          <a href={props && props.url}>
            <img src="/d3rest/v4/themes/images/LOGO" height="95" width="450" alt='Logo' style={{ maxHeight: '100%', width: 'auto' }} />
          </a>
        </div>
      </header>
      <div className="spacer" />
    </>
  );
}
